import useAsync from 'react-use/esm/useAsync'
import { MAX_FLOWS_TO_DOCUMENT } from '~/constants/commandLimits'
import { AgentRequest } from '~/protos/agents'
import { TaskParams } from './BaseTaskForm'

export const DOCUMENT_GENERATOR_MAX_FLOWS = MAX_FLOWS_TO_DOCUMENT
export const DOCUMENT_GENERATOR_FLOW_LIMIT_ERROR = `Select up to ${DOCUMENT_GENERATOR_MAX_FLOWS} flows for document generation`

const parseSelectedFlowNames = (flowNames: string): string[] =>
  flowNames
    .split(',')
    .map(flowName => flowName.trim())
    .filter(Boolean)

interface FlowDocsGeneratorFormProps {
  onChange: (task: TaskParams) => void
  flowNames: string | null
  disabled?: boolean
}

export function FlowDocsGeneratorForm({ onChange, flowNames }: FlowDocsGeneratorFormProps) {
  useAsync(async () => {
    if (flowNames != null) {
      const selectedFlowCount = parseSelectedFlowNames(flowNames).length
      const request = AgentRequest.fromPartial({
        command: { commandString: flowNames }
      })
      onChange?.({
        request,
        submitBlockedReason:
          selectedFlowCount > DOCUMENT_GENERATOR_MAX_FLOWS
            ? DOCUMENT_GENERATOR_FLOW_LIMIT_ERROR
            : undefined
      })
    }
  }, [flowNames, onChange])

  return null // FlowNameSelector is now in TaskForm
}
